import React from "react";
import moment from "moment";
import PropTypes from "prop-types";

import Translate from "utils/translate";

import DealStatusMessage from "./DealStatusMessage";

import styles from "./DealStatusMessage.css";

const { t } = new Translate("DealCancel");

const DisregardedDealMessage = ({ feedback }) => {
  const { actor, cancelDate, moveDate, outcome, reason } = feedback;
  const disregardSubtitle = (outcome || reason) && (
    <div className={styles.subtitle}>
      {outcome && <div>{t(`disregard_outcomes.${outcome}`)}</div>}
      {reason && <div>{t(`disregard_reasons.${reason}`)}</div>}
    </div>
  );

  const cancelSubtitle = (cancelDate || moveDate) && (
    <div className={styles.subtitle}>
      {reason && <div>{t(`disregard_reasons.${reason}`)}</div>}
      {cancelDate && <div>{`${t("cancelDate")} ${moment(cancelDate).format("L")}`}</div>}
      {cancelDate && <div>{`${t("moveDate")} ${moment(moveDate).format("L")}`}</div>}
    </div>
  );

  return (
    <DealStatusMessage
      actor={actor}
      subtitle={cancelDate || moveDate ? cancelSubtitle : disregardSubtitle}
    >
      {feedback.feedback}
    </DealStatusMessage>
  );
};

DisregardedDealMessage.propTypes = {
  feedback: PropTypes.shape({
    actor: PropTypes.shape({
      id: PropTypes.number.isRequired,
      fullName: PropTypes.string,
    }),
    outcome: PropTypes.oneOf(["move", "stay", "unknown", "other_outcome"]),
    reason: PropTypes.oneOf(["location", "price", "size", "quality", "unknown", "other_reason"]),
    feedback: PropTypes.string,
    cancelDate: PropTypes.string,
    moveDate: PropTypes.string,
  }),
};

export default DisregardedDealMessage;
